import { addPatientToList, removePatientFromLists, applyTimeToPatient, buildWaitLists } from 'Helper/listHelpers'
import _ from 'lodash'

function lobbyDashboardReducer(state = {}, action = {}) {
  let lists = {}
  let waitingInjectionWindow
  let withInjectionStaffWindow
  let waitingExcuseWindow

  switch (action.type) {
    case 'UPDATE_APP_CONFIG':
      if(action.key === 'CLINIC_LOCATION') {
        // reset lits if clinic location changes
        return {
          ...state,
          withInjectionStaffWindow: [],
          waitingInjectionWindow: [],
          waitingExcuseWindow: []
        }
      }
      return state
    case 'STORE_ME_READ_ALL':
    case 'STORE_ME_UPDATE':
      return {
        ...state,
        userTimezone: action.result?.timezone
      }
    case 'RESET_WAITLIST_LISTS':
      return {
        ...state,
        withInjectionStaffWindow: [],
        waitingInjectionWindow: [],
        waitingExcuseWindow: []
      }
    case 'STORE_WAITLIST_UPDATE':
    case 'STORE_WAITLIST_SEARCH':
    case 'STORE_WAITLIST_STREAM':
    case 'STORE_CLINIC_WAITLIST_STREAM':
      lists = buildWaitLists(action.result, _.cloneDeep(state))
      return {
        ...state,
        withInjectionStaffWindow: lists.withInjectionStaffWindow,
        waitingInjectionWindow: lists.waitingInjectionWindow,
        waitingExcuseWindow: lists.waitingExcuseWindow
      }
    case 'STORE_PATIENT_ENCOUNTER_CREATE':
    case 'STORE_PATIENT_ENCOUNTER_UPDATE':
      waitingInjectionWindow = [...(state.waitingInjectionWindow || [])]
      withInjectionStaffWindow = [...(state.withInjectionStaffWindow || [])]
      waitingExcuseWindow = [...(state.waitingExcuseWindow || [])]

      // first delete it from any lists
      lists = removePatientFromLists(action.result, { waitingInjectionWindow, withInjectionStaffWindow, waitingExcuseWindow })
      // then add it back to the correct list
      lists = addPatientToList(action.result, lists)
      return {
        ...state,
        withInjectionStaffWindow: lists.withInjectionStaffWindow,
        waitingInjectionWindow: lists.waitingInjectionWindow,
        waitingExcuseWindow: lists.waitingExcuseWindow
      }
    case 'UPDATE_TIME':
      // current state object mapped to new object
      waitingInjectionWindow = [...(state.waitingInjectionWindow || [])]
      withInjectionStaffWindow = [...(state.withInjectionStaffWindow || [])]
      waitingExcuseWindow = [...(state.waitingExcuseWindow || [])]

      waitingInjectionWindow = waitingInjectionWindow.map(patient => applyTimeToPatient(patient, state.userTimezone))
      waitingExcuseWindow = waitingExcuseWindow.map(patient => applyTimeToPatient(patient, state.userTimezone))
      withInjectionStaffWindow = withInjectionStaffWindow.map(patient => applyTimeToPatient(patient, state.userTimezone))

      return {
        ...state,
        // all times changed equally so no sorting needed
        withInjectionStaffWindow,
        waitingInjectionWindow,
        waitingExcuseWindow
      }
    default:
      return state
  }
}

export default lobbyDashboardReducer
